// @flow

import React from "react";

import spinner from "./spinner.gif";

type Props = {
    id: string,
    className?: string,
    type: string,
    status?: "" | "loading",
    disabled?: boolean,
    onClick?: () => void,
    children: any
};

export function Button(props: Props) {
    const cls = props.className || "";
    const clsStatus = props.status === "loading" ? "reece-btn--loading" : "";
    return (
        <button
            id={props.id}
            name={props.id}
            className={`reece-btn ${cls} ${clsStatus}`}
            type={props.type}
            disabled={!!props.disabled}
            onClick={props.onClick || noop}
        >
            {props.children}
            {props.status === "loading" && <img src={spinner} />}
        </button>
    );
}

function noop() {}
